/* ============================================================
   Domovoi · shared share-link helper  (window.DVShare)

   Same scheme as Considered (considered/helpers.js):
     utm_source=share
     utm_medium=native-share | copy-link
     utm_campaign=<page type>   e.g. home, curated_title
     utm_content=<the thing>    e.g. hero, tv-1396
   plus dataLayer {event:'share', method, content_type, item_id}.

   DVShare.share({ path, campaign, content, title, text })
     → Promise<'shared' | 'copied' | 'cancelled' | 'failed'>
   DVShare.keepTracking(path) → path with any utm_/click-id params
     from the current URL carried over (use on replaceState).
   ============================================================ */
import { ORIGIN } from './config.js';

(function () {
  var TRACKING = /^(utm_[a-z]+|gclid|fbclid|msclkid|dclid)$/;
  function keepTracking(path) {
    var out = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (v, k) { if (TRACKING.test(k)) out.set(k, v); });
    var t = out.toString();
    return t ? path + (path.indexOf('?') >= 0 ? '&' : '?') + t : path;
  }
  function url(path, opts, medium) {
    var u = new URL(path, ORIGIN);   // never the page's own origin: in the app it is not domovoi.ca
    u.searchParams.set('utm_source', 'share');
    u.searchParams.set('utm_medium', medium);
    u.searchParams.set('utm_campaign', opts.campaign);
    if (opts.content) u.searchParams.set('utm_content', opts.content);
    return u.toString();
  }
  function share(opts) {
    var done = function (method) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'share', method: method, content_type: opts.campaign, item_id: opts.content || '' });
      return method === 'native-share' ? 'shared' : 'copied';
    };
    function copy() {
      var link = url(opts.path, opts, 'copy-link');
      if (!navigator.clipboard) return Promise.resolve('failed');
      return navigator.clipboard.writeText(link).then(function () { return done('copy-link'); }, function () { return 'failed'; });
    }
    if (navigator.share) {
      return navigator.share({ title: opts.title, text: opts.text, url: url(opts.path, opts, 'native-share') })
        .then(function () { return done('native-share'); })
        .catch(function (e) { return e && e.name === 'AbortError' ? 'cancelled' : copy(); });
    }
    return copy();
  }
  // Plain-HTML pages: <button data-dv-share data-campaign="home" data-content="hero"
  //   data-title="…" data-text="…" data-path="/">…</button>
  function wire(root) {
    (root || document).querySelectorAll('[data-dv-share]').forEach(function (el) {
      if (el._dvShare) return; el._dvShare = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var label = el.querySelector('[data-dv-share-label]') || el, was = label.textContent;
        share({ path: el.dataset.path || '/', campaign: el.dataset.campaign, content: el.dataset.content, title: el.dataset.title, text: el.dataset.text })
          .then(function (r) {
            if (r !== 'copied' && r !== 'failed') return;
            label.textContent = r === 'copied' ? 'Link copied' : 'Couldn’t copy the link';
            setTimeout(function () { label.textContent = was; }, 2200);
          });
      });
    });
  }
  window.DVShare = { share: share, url: url, keepTracking: keepTracking, wire: wire };
  if (document.readyState !== 'loading') wire(); else document.addEventListener('DOMContentLoaded', function () { wire(); });
})();

export var DVShare = window.DVShare;
